/**
 * This centralized utility function replaces multiple duplicate implementations that existed across the codebase (DWH-2275).
 */
export const openPrivacySettings = () => {
  // check for its existence before calling
  if (window.UC_UI && window.UC_UI.showSecondLayer) {
    window.UC_UI.showSecondLayer()
  } else {
    console.error('UserCentrics UI is not available.')
  }
}
